module.exports = __webpack_public_path__ + "img/Online-Groceries-rafiki.3592a1a6.png";